import { Components, Theme } from '@mui/material';
import {
  FONT_SCALE_CAP_DENSE,
  getResponsiveFontSizeAtScale,
  getScaleFactor,
} from '../watchdutyTheme.utils';

const TAB_MIN_HEIGHT = 46;

/** Top indicator without border meeting side dividers. */
const TAB_SELECTED_INDICATOR_SHADOW =
  'inset 0 3px 0 0 var(--mui-palette-tab-selectedIndicator)';

export const getMuiTab = (
  theme: Theme,
  scaleFactor: number = getScaleFactor(),
): Components['MuiTab'] => ({
  styleOverrides: {
    root: {
      flex: 1,
      gap: 8,
      minHeight: TAB_MIN_HEIGHT,
      padding: '12px 16px',
      fontSize: getResponsiveFontSizeAtScale('1rem', scaleFactor, {
        maxScale: FONT_SCALE_CAP_DENSE,
      }),
      lineHeight: '22px',
      letterSpacing: 0,
      textTransform: 'none',
      display: 'inline-flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: 1,
      '& .MuiTab-label': {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
      },
      '&:not(.Mui-selected)': {
        backgroundColor: 'var(--mui-palette-tab-inactive)',
        color: 'var(--mui-palette-text-primary)',
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover': {
          backgroundColor: 'var(--mui-palette-tab-inactiveHover)',
          opacity: 1,
          '@media (hover: none)': {
            backgroundColor: 'var(--mui-palette-tab-inactive)',
          },
        },
      },
      '&.Mui-selected': {
        backgroundColor: 'var(--mui-palette-background-default)',
        color: 'var(--mui-palette-text-primary)',
        fontWeight: theme.typography.fontWeightBold,
        boxShadow: TAB_SELECTED_INDICATOR_SHADOW,
      },
    },
  },
});
